// BI catalog: https://bo.wix.com/bi-catalog-webapp/#/sources/5/events/814?artifactId=gdpr-statics

function getHostUrl() {
  let biUrl = 'https://frog.wix.com/';
  const hostName = window.location && window.location.hostname || '';
  if (hostName.indexOf('.editorx.com') > -1) {
    biUrl = 'https://frog.editorx.com/';
  }
  return biUrl;
}
export const logger = {
  openedPanel,
  onSettingsChanged
};
function log(eventData) {
  let logURI = getHostUrl() + "gdpr?src=5";
  eventData.url = location.href;
  Object.keys(eventData).forEach(key => {
    logURI += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(eventData[key]);
  });
  return sendTheBI(logURI);
}
function sendTheBI(logURI) {
  if (isIOS()) {
    return sendImage(logURI);
  } else {
    return sendBeacon(logURI) || sendImage(logURI);
  }
}
function isIOS() {
  const userAgent = navigator.userAgent || '';
  return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);
}
function sendBeacon(url) {
  let sent = false;
  try {
    if (navigator && navigator.sendBeacon) {
      sent = navigator.sendBeacon(url);
    }
  } catch (e) {
    // Linty linter linted something
  }
  return sent;
}
function sendImage(url) {
  const img = new Image();
  img.src = url;
  return true;
}
function openedPanel(origin) {
  log({
    evid: 814,
    action: 'settings',
    origin
  });
}
function onSettingsChanged(oldValue, newValue) {
  log({
    evid: 1727,
    new_value: newValue,
    old_value: oldValue
  });
}
//# sourceMappingURL=bi-logger-service.js.map